/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
import React, { useState, useEffect } from "react";
import { useForm, type UseFormReturn } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import {
  Button,
  Calendar,
  Combobox,
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@repo/ui";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { useGetRoutes, useGetServiceTypes } from "utils/apis/lookups.api";

import { LucideFileEdit, TrashIcon } from "lucide-react";

const periodTypes = [
  {
    name: "Both",
    value: "Both",
  },
  {
    name: "Weekly",
    value: "Weekly",
  },
  {
    name: "Monthly",
    value: "Monthly",
  },
];

const formSchema = z.object({
  serviceType: z.string().min(1, { message: "Service Type is required." }),
  jobType: z.string().min(1, { message: "Job Type is required." }),
  routeNo: z.string().min(1, { message: "Route No. is required." }),
  scheduleType: z.string().min(1, { message: "Period Type is required." }),
  weekDays: z.array(z.string()).optional(),
  monthlyDates: z.array(z.date()).optional(),
  monthDates: z.array(z.string()).optional(),
});

const defaultValues = {
  serviceType: "",
  jobType: "",
  routeNo: "",
  scheduleType: "",
};

export default function ServicesScheduled({
  selectedLocation,
  setSelectedLocation,
  setIsAddNewOpen,
}: {
  selectedLocation: any;
  setSelectedLocation: any;
  setIsAddNewOpen: any;
}) {
  const { data: serviceTypes } = useGetServiceTypes();
  const { data: allInRouteTeams } = useGetRoutes();

  const [services, setServices] = useState<any[]>([]);
  const [addServices, setAddServices] = useState<boolean>(false);
  const [editId, setEditId] = useState<string | null>(null);

  const form = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
    defaultValues,
  });

  const serviceType = form.watch("serviceType");
  const periodType = form.watch("scheduleType");

  const jobTypes = serviceTypes?.find(
    (i) => i.description === serviceType,
  )?.jobTypes;

  function onSubmit(values: z.infer<typeof formSchema>) {
    setIsAddNewOpen(true);
    if (values.scheduleType === "Weekly") {
      values.monthDates = [];
    } else if (values.scheduleType === "Monthly") {
      values.weekDays = [];
    }
    const serviceSchedules = services.slice() || [];
    if (editId) {
      const filterServicesData = serviceSchedules.map((item) => {
        if (item?.deleteId === editId) {
          return { ...values, deleteId: item?.deleteId };
        }
        return item;
      });
      setServices(filterServicesData);
      setEditId(null);
      setSelectedLocation((prev: any) => ({
        ...prev,
        serviceSchedules: filterServicesData,
      }));
    } else {
      serviceSchedules.push({ ...values, deleteId: crypto.randomUUID() });
      setServices(serviceSchedules);
      setSelectedLocation((prev: any) => ({ ...prev, serviceSchedules }));
    }
    form.reset(defaultValues);
  }

  function ActionCell(props: any) {
    const { dataItem } = props;

    const handleDelete = (id: string) => {
      let filterContainerData = services.slice();
      filterContainerData = filterContainerData.filter(
        (item) => item?.deleteId !== id,
      );
      setServices(filterContainerData);
      setSelectedLocation((prev: any) => ({
        ...prev,
        serviceSchedules: filterContainerData,
      }));
    };

    const handleEdit = (id: string) => {
      const filterContainerData = services.find(
        (item) => item?.deleteId === id,
      );
      if (filterContainerData) {
        form.reset({
          ...filterContainerData,
          monthlyDates: filterContainerData?.monthDates?.map((d: string) => {
            const date = new Date();
            date.setDate(Number(d));
            return date;
          }),
        });
        setTimeout(() => {
          form.setValue("jobType", filterContainerData?.jobType);
        }, 50);
        setEditId(id);
      }
    };

    return (
      <td {...props}>
        <div className="flex gap-1">
          <Button variant="ghost" size="icon" type="button">
            <LucideFileEdit
              className="text-secondary"
              onClick={() => {
                handleEdit(dataItem?.deleteId);
              }}
            />
          </Button>
          <Button variant="ghost" size="icon" type="button">
            <TrashIcon
              className="text-red-500"
              onClick={() => {
                handleDelete(dataItem?.deleteId);
              }}
            />
          </Button>
        </div>
      </td>
    );
  }

  useEffect(() => {
    if (selectedLocation?.serviceSchedules?.length && !services.length) {
      setServices(() =>
        selectedLocation?.serviceSchedules?.map((item: any) => ({
          ...item,
          deleteId: crypto.randomUUID(),
        })),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedLocation?.serviceSchedules]);

  return (
    <>
      <div className="flex gap-3 flex-wrap">
        <div className="flex gap-2 w-[calc(50%_-_8px)]">
          <strong>Barcode:</strong>
          <span>{selectedLocation?.barcode}</span>
        </div>{" "}
        <div className="flex gap-2 w-[calc(50%_-_8px)]">
          <strong>Location Id:</strong>
          <span>{selectedLocation?.locationId}</span>
        </div>
        <div className="flex gap-2 w-[calc(50%_-_8px)]">
          <strong>Customer:</strong>
          <span>{selectedLocation?.customer}</span>
        </div>
        <div className="flex gap-2 w-[calc(50%_-_8px)]">
          <strong>Location Type:</strong>
          <span>{selectedLocation?.locationType}</span>
        </div>
      </div>
      <Button
        variant="secondary"
        className="ml-auto block max-w-40 w-full mt-3"
        onClick={() => {
          setAddServices(true);
        }}
      >
        Add Schedule Line
      </Button>
      {services ? (
        <TooltipProvider>
          <Grid data={services} className="mt-3">
            <GridColumn field="serviceType" title="Service Type" />
            <GridColumn field="jobType" title="Job Type" />
            <GridColumn field="routeNo" title="Route No" />

            <GridColumn
              field="weekDays"
              title="Week Days"
              cell={({ dataItem }) => (
                <td>
                  <Tooltip>
                    <TooltipTrigger asChild>
                      <p className="text-ellipsis overflow-hidden">
                        {dataItem?.weekDays?.join(",")}
                      </p>
                    </TooltipTrigger>
                    <TooltipContent>
                      {dataItem?.weekDays?.join(",")}
                    </TooltipContent>
                  </Tooltip>
                </td>
              )}
            />

            <GridColumn
              field="monthDates"
              title="Month Dates"
              cell={({ dataItem }) => (
                <td>
                  <Tooltip>
                    <TooltipTrigger asChild>
                      <p className="text-ellipsis overflow-hidden">
                        {dataItem?.monthDates?.join(",")}
                      </p>
                    </TooltipTrigger>
                    <TooltipContent>
                      {dataItem?.monthDates?.join(",")}
                    </TooltipContent>
                  </Tooltip>
                </td>
              )}
            />
            <GridColumn cell={ActionCell} title="Action" />
          </Grid>
        </TooltipProvider>
      ) : null}
      {addServices || editId ? (
        <Form {...form}>
          <form
            onSubmit={form.handleSubmit(onSubmit)}
            className="grid gap-3 grid-cols-3 mt-3"
          >
            <FormSelect
              form={form}
              data={
                serviceTypes?.map(({ description }: any) => ({
                  name: description,
                  value: description,
                })) || []
              }
              name="serviceType"
              label="Service Type"
              placeholder="Select Service Type"
            />
            <FormSelect
              form={form}
              data={
                jobTypes?.map(({ description }: any) => ({
                  name: description,
                  value: description,
                })) || []
              }
              name="jobType"
              label="Job Type"
              placeholder="Select Job Type"
            />
            <FormCombobox
              form={form}
              data={allInRouteTeams?.map((m: any) => ({
                value: String(m.routeNo),
                label: `${m.routeNo} (${m.description})`,
              }))}
              name="routeNo"
              label="Route"
              placeholder="Select Route"
            />
            <FormSelect
              form={form}
              data={periodTypes}
              name="scheduleType"
              label="Schedule Type"
              placeholder="Select Period Type"
            />
            <div className="flex flex-col gap-3 mt-3 col-span-3">
              {["Weekly", "Both"].includes(periodType) ? (
                <div className="flex gap-3 ">
                  <b>Day Of Week:</b>
                  <div>
                    <FormField
                      control={form.control}
                      name="weekDays"
                      render={({ field }) => (
                        <FormItem>
                          <div className="flex items-center">
                            {[
                              { label: "Mon", value: "Monday" },
                              { label: "Tue", value: "Tuesday" },
                              { label: "Wed", value: "Wednesday" },
                              { label: "Thu", value: "Thursday" },
                              { label: "Fri", value: "Friday" },
                              { label: "Sat", value: "Saturday" },
                              { label: "Sun", value: "Sunday" },
                            ].map((i) => (
                              <span
                                className="cursor-pointer block p-3 border-l border-t border-b first:border-l last:border-r first:rounded-l-md last:rounded-r-md data-[state=active]:bg-secondary data-[state=active]:text-white data-[state=active]:border-color-secondary"
                                data-state={
                                  field.value?.includes(i.value) ? "active" : ""
                                }
                                onClick={() => {
                                  let array = field.value || [];
                                  if (!array.includes(i.value)) {
                                    array.push(i.value);
                                  } else {
                                    array = array.filter((r) => r !== i.value);
                                  }
                                  field.onChange(array);
                                }}
                                key={i.value}
                              >
                                {i.label}
                              </span>
                            ))}
                          </div>
                          <FormMessage />
                        </FormItem>
                      )}
                    />
                  </div>
                </div>
              ) : null}
              {["Monthly", "Both"].includes(periodType) ? (
                <div className="flex gap-3">
                  <b>Day Of Month:</b>
                  <div>
                    <FormField
                      control={form.control}
                      name="monthlyDates"
                      render={({ field }) => (
                        <FormItem>
                          <Calendar
                            showOutsideDays={false}
                            mode="multiple"
                            selected={field.value}
                            onSelect={(val) => {
                              field.onChange(val);
                              form.setValue(
                                "monthDates",
                                val?.map((d) => String(d.getDate())),
                              );
                            }}
                            className="rounded-lg border"
                            disableNavigation
                          />
                          <FormMessage />
                        </FormItem>
                      )}
                    />
                  </div>
                </div>
              ) : null}
            </div>

            <div className="flex gap-3">
              <Button variant="secondary" type="submit" className="w-max">
                {editId ? "Update" : "Add"}
              </Button>
              {editId ? (
                <Button
                  variant="outline"
                  type="button"
                  className="w-max"
                  onClick={() => {
                    setEditId(null);
                    form.reset(defaultValues);
                  }}
                >
                  Cancel
                </Button>
              ) : null}
            </div>
          </form>
        </Form>
      ) : null}
    </>
  );
}

function FormSelect({
  form,
  name,
  label,
  placeholder,
  data,
  onChange,
}: {
  form: UseFormReturn<z.infer<typeof formSchema>>;
  name: keyof z.infer<typeof formSchema>;
  label: string;
  placeholder?: string;
  data?: { name: string; value: any }[];
  onChange?: (e: any) => void;
}) {
  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem>
          <FormLabel>{label}</FormLabel>
          <Select
            onValueChange={(e) => {
              field.onChange(e);
              onChange?.(e);
            }}
            value={field.value as any}
          >
            <FormControl>
              <SelectTrigger>
                <SelectValue placeholder={placeholder} />
              </SelectTrigger>
            </FormControl>
            <SelectContent>
              {data?.map((item) => (
                <SelectItem key={item.value} value={item.value}>
                  {item.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}

function FormCombobox({
  form,
  name,
  label,
  placeholder,
  data,
  onChange,
  disabled,
  ...props
}: {
  form: UseFormReturn<z.infer<typeof formSchema>>;
  name: keyof z.infer<typeof formSchema>;
  label: string;
  placeholder: string;
  data?: { label: string; value: any }[];
  disabled?: boolean;
  onChange?: (e: any) => void;
}) {
  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem>
          <FormLabel>{label}</FormLabel>
          <Combobox
            value={field.value as any}
            setValue={(e: string) => {
              field.onChange(e);
              onChange?.(e);
            }}
            data={data}
            placeholder={placeholder}
            disabled={disabled}
            {...props}
          />
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
